import React, { FunctionComponent } from 'react';
import { CardListItemSize } from './CardListItem';
export function wrapCardListItemSubComponent<TProps extends {
  cardListItemInfo: CardListItemInfo;
}>(SubComponent: CardListItemSubComponent<TProps>): WrappedCardListItemSubComponent<TProps> {
  return props => {
    const {
      cardListItemInfo,
      ...remainingProps
    } = props;
    if (!cardListItemInfo) {
      return <span>This component must be used inside a CardListItem</span>;
    }
    const subComponentProps = {
      cardListItemInfo,
      ...remainingProps
    } as TProps;
    return <SubComponent {...subComponentProps}></SubComponent>;
  };
}
export type CardListItemSubComponentProps<T> = T & {
  cardListItemInfo: CardListItemInfo;
};
export type CardListItemSubComponent<T> = FunctionComponent<T & {
  cardListItemInfo: CardListItemInfo;
}>;
export type WrappedCardListItemSubComponent<T> = FunctionComponent<Omit<T, 'cardListItemInfo'> & {
  cardListItemInfo?: CardListItemInfo;
}>;
export type WrappedCardListItemSubComponentElement<T = Record<string, never>> = React.ReactElement<T & {
  cardListItemInfo: CardListItemInfo;
}>;
export type CardListItemInfo = {
  size: CardListItemSize;
};